import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clickTargets: HTMLElement[]

  static targets = [ "click" ]

  click() {
    this.clickTargets.forEach(target => target.click())
  }
}
